import { Button, Text } from "@microbeta/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { paths } from "../../../../../shared/utils/routing";
import styles from "../request-reset-password.module.scss";

type Props = {
  onTryAgainPressed: () => void;
};

const EmailInstructions = ({ onTryAgainPressed }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Text className={styles.instruction} variant="small">
        {t("emailInstructions.passwordInstructionsSent")}
      </Text>
      <Text className={styles.instruction} variant="small">
        {t("emailInstructions.didNotReceiveEmail")}
      </Text>
      <Button
        onClick={onTryAgainPressed}
        variant="secondary"
        size="small"
        type="submit"
      >
        {t("emailInstructions.tryAgain")}
      </Button>
      <Text as="span" variant="small">
        {t("common.or")}
      </Text>
      <Link to={paths.signin}>
        <Text className={styles.signInLink} as="span" variant="small">
          {t("enterEmailContent.backToLogin")}
        </Text>
      </Link>
    </>
  );
};

export default EmailInstructions;
